export class CreateTimeEntryAction {
  static readonly type = '[Project] Create Time Entry';

  constructor(public timeEntry) {}
}
